import Module from 'mini-module-switcher/lib/schema/Module';
import selectFolderWithFallback from '../utils/selectFolderWithFallback';
import switchModule from 'owa-mail-store/lib/actions/switchModule';
import { getMailPath } from 'owa-url';
import { targetedAdLgpdDismissed } from 'mini-lgpd-opt-in/lib/utils/targetedAdUtils';
import { targetedAdV3Dismissed } from 'mini-gdprv3-ads-opt-in/lib/utils/targetedAdUtils';
import { targetedEUAdsDismissed } from 'owa-euemailads-optin/lib/utils/targetedAdUtils';

export interface MailFolderRouteParameters {
    folderId: string;
}

/**
 * Handle folderId route
 */
export function mailFolderRouteHandler(params: MailFolderRouteParameters) {
    // When we reach a mail folder route, switch selected module to mail so that mail list view is rendered
    targetedEUAdsDismissed();
    targetedAdLgpdDismissed();
    targetedAdV3Dismissed();
    switchModule(Module.Mail);
    selectFolderWithFallback(params.folderId);
}

export function mailFolderCleanupRouteHandler(params: any) {
    const routeParams = window.location.pathname.replace(getMailPath(), '').split('/');
    // Return false if we're not in List view
    // routeParams for LV would look like [folderIdOrName]
    if (routeParams?.length > 1) {
        return false;
    }

    // Always block back button from list view as it is the default view.
    return true;
}
